import axiosInstance from "@/plugins/axios";

export const NotificationService = {
  list: async ({
    usecase,
    role,
    userId,
    page,
    perPage,
    id,
    isafeno,
    email,
  }) => {
    const response = await axiosInstance.post(`cms/notification`, {
      usecase,
      role,
      userId,
      id,
      page,
      perPage,
      isafeno,
      email,
    });
    return response.data;
  },
  markAsRead: async (id) => {
    const response = await axiosInstance.put(`cms/notification/nc/read/${id}`);
    return response.data;
  },
};
